import { TableDataType } from 'module/ui/components/atoms/rich-text-editor/toolbar/table-toolbar';
import { Color } from 'module/ui/components/styles/colors';
import {
  ConditionalFormulaFieldMeta,
  SimpleFormulaFieldMeta,
} from './formula-field-types';

export enum FieldObjectType {
  Signal = 'SIGNAL',
  Project = 'PROJECT',
  ProjectPhase = 'PROJECT_PHASE',
  Task = 'TASK',
  Users = 'USERS',
  Financial = 'FINANCIAL',
  Sprint = 'SPRINT',
  Company = 'COMPANY',
  Timeoff = 'TIMEOFF',
  Invoice = 'INVOICE',
  Meeting = 'MEETING',
  Email = 'EMAIL',
}
export enum FieldObjectSubType {
  Default = 'DEFAULT',
  Skill = 'SKILL',
  ExternalUser = 'EXTERNAL_TEAM_MEMBER',
  InvoiceProject = 'INVOICE_PROJECT',
}
export enum FieldDataType {
  Text = 'TEXT',
  MultiLineText = 'MULTI_LINE_TEXT',
  Number = 'NUMBER',
  Boolean = 'BOOLEAN',
  Date = 'DATE',
  User = 'USER',
  Note = 'NOTE',
  Upload = 'UPLOAD',
}
export enum FieldType {
  SingleSelect = 'SINGLE_SELECT',
  MultiSelect = 'MULTI_SELECT',
}
export enum FieldTypeDisplay {
  Level = 'LEVEL',
}
export type FieldValueType = string | number | boolean | number[] | null;
export type FieldMetaDataOption<T extends FieldValueType> = {
  label: string;
  value: T;
  description?: string;
  fieldOptionMeta?: {
    isAiGenerated?: boolean;
    isDescriptionAiGenerated?: boolean;
    optionType?: TableDataType;
    choices?: SingleAndMultiSelectFieldOption[];
  };
  color?: Color;
  position?: number;
  group?: number;
  deletable?: boolean;
  editable?: boolean;
  active?: boolean;
};
export type SingleAndMultiSelectFieldOption = FieldMetaDataOption<number>;
interface SingleAndMultiSelectFieldMeta {
  options: SingleAndMultiSelectFieldOption[];
}
export type FieldMetaData = SingleAndMultiSelectFieldMeta;

export interface FieldOptionBase<T = number> {
  color?: Color;
  value: T;
  label: string;
  position?: number;
  active?: boolean;
  valueStr?: string;
}

export interface FieldOption<T> extends FieldOptionBase {
  color: Color;
  group: T;
}

export interface Field {
  fieldId: number;
  fieldName: string;
  fieldLabel?: string;
  description?: string;
  metaData?: FieldMetaData;
  isEnabled: boolean;
  fieldType: string;
  fieldDataType: FieldDataType;
  private: boolean;
  fieldIndex?: number;
  customField: boolean;
  optionsAvailable: boolean;
  fieldSectionId: number;
  formulaFieldMeta: SimpleFormulaFieldMeta | ConditionalFormulaFieldMeta;
  objectType: FieldObjectType;
  objectSubType?: FieldObjectSubType;
  fieldTypeDisplay?: FieldTypeDisplay;
  userGroupIds: number[];
  isEditable: boolean;
  userCreated?: boolean;
}
export interface FieldWithValue extends Field {
  value?: FieldValueType;
}

export type CreateFieldPayload = Partial<Omit<Field, 'fieldId'>>;
export type FieldLite = Pick<Field, 'fieldId' | 'metaData'>;
export type FieldValue = FieldLite & { fieldValue?: FieldValueType };

export interface AccountFields {
  accountId: number | null;
  accountName: string | null;
  objectType: string | null;
  fields: Field[];
}
export type Decimals = number[];
export type FieldAccessMeta = Record<
  FieldObjectType | FieldObjectSubType,
  Decimals
>;
export type Base3Number = number;
export type FieldAccessMetaInBase3 = Record<
  FieldObjectType | FieldObjectSubType,
  Base3Number[]
>;
